// extracted by mini-css-extract-plugin
export var cardLocked = "CardLocked-module--cardLocked--NceD4";
export var orange = "CardLocked-module--orange--1ujsB";
export var purple = "CardLocked-module--purple--36-R4";
export var blue = "CardLocked-module--blue--3OxVk";
export var cardLockedChest = "CardLocked-module--cardLockedChest--3nwdf";
export var cardUnlockedDateWrapper = "CardLocked-module--cardUnlockedDateWrapper--2f6w3";
export var cardLockedDate = "CardLocked-module--cardLockedDate--1Fg9I";